export const HOME = {
  emergentLink: 'home-emergent-link',
  logo: 'brand-logo',
  contactFormName: 'contact-form-name-input',
  contactFormEmail: 'contact-form-email-input',
  contactFormPhone: 'contact-form-phone-input',
  contactFormService: 'contact-form-service-select',
  contactFormMessage: 'contact-form-message-textarea',
  contactFormSubmit: 'contact-form-submit-button',
  contactFormSuccessAlert: 'contact-form-success-alert',
  contactFormErrorAlert: 'contact-form-error-alert',
  serviceCard: 'service-card',
  teamCard: 'team-card',
  impressumTrigger: 'impressum-trigger-button',
  datenschutzTrigger: 'datenschutz-trigger-button',
  impressumDialog: 'impressum-dialog-container',
  datenschutzDialog: 'datenschutz-dialog-container',
  closeDialog: 'dialog-close-button',
  adminToggle: 'admin-dashboard-toggle',
  adminPinInput: 'admin-dashboard-pin-input',
  adminMessageRow: 'admin-dashboard-message-row',
  adminDeleteButton: 'admin-dashboard-delete-button'
};
